import { useEffect, useState } from "react";

import { useTitles } from "../../../../Recoil/Novel/Title";
import { useEpisodes } from "../../../../Recoil/Novel/Episode";

import { ContentsType, readContents } from "../../../../Data/Novel/Contents";

import EpubViewer from "./Component/EpubViewer";
import EpisodeInformation from "./Component/EpisodeInformation";
import EpisodeFooter from "./Component/EpisodeFooter";

import './index.scss';
import UIGroup from "./Component/UIGroup";
import { fn, waitImageLoaded } from "../../../../Functions";
import LoadingCircle from "../../../../Components/LoadingCircleAnimated";
import { isAxiosError } from "axios";
import { useToastAlert } from "design-system/Toast";
import { Button } from "@mui/material";
import { logBehavior } from "../../../../Data/Behavior";
import CommentArea from "./Component/CommentArea";

const EpisodeHome = ({
    serviceId, titleId, episodeId, snapshotId,
}: {
    serviceId?: string, titleId?: string, episodeId?: string, snapshotId?: string,
    query: string, hash: string, isClient: any
}) => {
    const [isBarVisible, setIsBarVisible] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [thumbnail, setThumbnail] = useState<string | null>(null);

    const [ content, setContent ] = useState<ContentsType | null>(null);

    const { fetch: fetchTitle, titleObject } = useTitles();
    const { fetch: fetchEpisode, episodeObject } = useEpisodes();
    const { toastAlert } = useToastAlert();
    
    const title = titleObject[`${serviceId}:${titleId}`];

    const episodes = episodeObject[`${serviceId}:${titleId}`];
    const episode = (episodes || []).length > 0 ? episodes.find( episode => episode.episodeId === content?.data?.episodeId ) : undefined;


    // Load content handler that checks age verification first
    const loadContent = async () => {
        if (!serviceId || !titleId || !episodeId) return;

        try {
            setIsLoading(true);
            const contentRes = await readContents(serviceId, titleId, episodeId);
            setIsLoading(false);
            if (!contentRes) return;
            setContent(contentRes);
            
            localStorage.setItem(`contents:${serviceId}:${titleId}:${episodeId}`, Math.floor(Date.now() / 1000).toString());
        } catch(e) {
            setIsLoading(false);
            if (isAxiosError(e) && e.status === 429) {
                toastAlert({iconType:"error", message:"최근 10분 동안 너무 많은 요청이 발생했습니다. \n잠시 후 다시 시도해주세요."});
            }
            console.error(e);
        }
    };

    useEffect(()=>{
        if (!serviceId || !titleId) return;
       
        fetchTitle([{serviceId, titleId}]);
        fetchEpisode({serviceId, titleId});

    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[serviceId, titleId]);

    useEffect(()=>{
        loadContent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[serviceId, titleId, episodeId]);

    useEffect(()=>{
        if (title?.timeRemain > 0) {
            return;
        }
        if ( !["000005", "000010", "000015"].includes(episodeId ?? "") ) {
            return;
        }

        toastAlert({
            message: <div style={{
                display:"flex", flexDirection:"row", alignItems:"center", justifyContent:"space-between",
                width: 340
            }}>
                {"10%할인 적용받고\n막힘없이 정주행해 보세요!"}
                <Button
                    onClick={(e)=>{
                        logBehavior('click-payment-5th-ep-nudge', {serviceId, titleId});
                        fn.gotoByAnchor(e);
                    }}
                    href={`/payment/${serviceId}/${titleId}`}
                    style={{fontWeight:"bold", marginLeft:"10px"}}
                >{"지금 바로 확인"}</Button>
            </div>
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[episodeId])

    useEffect(()=>{
        const episode = episodeObject[`${serviceId}:${titleId}`]?.find(episode => episode.episodeId === episodeId);

        if (!episode || !episode.thumbnail) {
            return;
        }

        (async()=>{
            try {
                await waitImageLoaded(episode.thumbnail);
                setThumbnail(episode.thumbnail);
            }catch(e) {
                // image load error
            }
        })();
    },[episodeObject, serviceId, titleId, episodeId]);

    useEffect(() => {
        const barVisibilityControl = () => {
            if (!isBarVisible) return;
            setIsBarVisible(false);
        };

        window.addEventListener('scroll', barVisibilityControl);

        return () => {
            window.removeEventListener('scroll', barVisibilityControl);
        };
    }, [isBarVisible]);

    if (!(serviceId || titleId || episodeId)) {
        return <></>;
    }

    return (<div className={"EpisodeHomeArea"}
        onClick={(e) => {setIsBarVisible(!isBarVisible)}}
    >
        {title && episodeId === "000001"
            && <EpisodeInformation title={title} />}

        {content?.data?.data 
            && <EpubViewer dataUrl={content?.data?.data[0]} />}
        {thumbnail && <img className={"EpisodeThumbnail"} src={thumbnail} alt={"thumbnail"} />}
        {title && episode 
            && <EpisodeFooter {...{title, episode}} />}
        {title && episodeId
            && <CommentArea {...{title, episodeId}}/>}
        {serviceId && titleId && episodeId
            && <UIGroup {...{
                serviceId, titleId, episodeId,
                isBarVisible, onClose: () => setIsBarVisible(false),
            }} />}
        <LoadingCircle show={isLoading} />
    </div>
    )
}

export default EpisodeHome;